import React from "react";
import { Link } from "react-router-dom";
import { HelpCircle, ArrowRight, Mail } from "lucide-react";
import { FAQS } from "../mock";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

const FAQ = () => {
  return (
    <div>
      <section className="relative bg-gradient-to-b from-blue-50 to-white border-b border-slate-200">
        <div className="absolute inset-0 fesx-grid-bg opacity-60" />
        <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16 text-center">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-blue-600 text-white flex items-center justify-center">
            <HelpCircle className="h-7 w-7" />
          </div>
          <h1 className="mt-5 font-display font-extrabold text-4xl text-slate-900">Common Questions Answered</h1>
          <p className="mt-3 text-lg text-slate-600">Everything you need to know about ordering research compounds from FesX.</p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="rounded-xl border border-slate-200 bg-white px-5">
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-10 rounded-2xl border border-slate-200 bg-slate-50 p-8 text-center">
          <Mail className="h-8 w-8 text-blue-600 mx-auto" />
          <h3 className="mt-3 font-display font-bold text-xl text-slate-900">Still have questions?</h3>
          <p className="mt-1.5 text-slate-500">Our team is happy to help with documentation and order enquiries.</p>
          <Link to="/contact" className="mt-5 inline-flex items-center gap-2 rounded-xl bg-blue-600 text-white font-semibold px-6 py-3 hover:bg-blue-700 transition-colors">
            Contact Support <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
